import { useState } from 'react';
import Calendar from './components/Calendar';
import Schedule from './components/Schedule';
import './App.css';
import { Value } from './types';
import useApiCall from './hooks/useApiCall';
import { API_URL_MAYOR, API_URL_SECRETARY } from './config';
import { formatURL } from './utils';


function App({ siteID, urlContext, apiType, calendarType }: { siteID: string | null, urlContext: string | null, apiType: string | null, calendarType: string | null}) {
  const [value, onChange] = useState<Value>(new Date());
  const { data, loading } = useApiCall(formatURL(apiType === "secretario" ? API_URL_SECRETARY : API_URL_MAYOR, value, siteID, calendarType));

  return (
    <div className="psp-calendar-app">
      <Schedule date={value} loading={loading} items={data?.items || []} onChange={onChange} urlContext={urlContext} />
      <Calendar onChange={onChange} value={value} />
    </div>
  );
}
export default App;
